import { useNuxtApp } from "#imports";
export const useCookieControl = () => useNuxtApp().$cookies;
